import { Permission } from '@/lib/permissions/v1'

export enum SecretRouteName {
    Index = 'system.secrets.index',
    Create = 'system.secrets.create',
    Edit = 'system.secrets.edit',
    Details = 'system.secrets.details',
    Logs = 'system.secrets.logs',
    LogDetails = 'system.secrets.log-details',
}

export default {
    path: 'secrets',
    name: SecretRouteName.Index,
    component: () => import('@/views/system/secrets/Index.vue'),
    meta: {
        auth: true,
        label: 'Secrets',
        icon: 'fal fa-key fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: Permission.SecretViewAny,
    },
    children: [
        {
            path: 'create',
            name: SecretRouteName.Create,
            component: () => import('@/views/system/secrets/Index.vue'),
            meta: {
                auth: true,
                label: 'Create Secret',
                icon: 'fal fa-globe fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: Permission.SecretCreate,
            },
        },
        {
            path: ':secretUuid/edit',
            name: SecretRouteName.Edit,
            component: () => import('@/views/system/secrets/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit Secret',
                icon: 'fal fa-globe fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: Permission.SecretUpdate,
            },
        },
        {
            path: ':secretUuid/details',
            name: SecretRouteName.Details,
            component: () => import('@/views/system/secrets/Index.vue'),
            meta: {
                auth: true,
                label: 'Details',
                icon: 'fal fa-globe fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: Permission.SecretView,
            },
        },
        {
            path: `:secretUuid/logs`,
            name: SecretRouteName.Logs,
            component: () => import('@/views/system/secrets/Index.vue'),
            meta: {
                label: 'Secret Logs',
                auth: true,
                permission: Permission.EventView,
            },
            children: [
                {
                    path: `:logId/details`,
                    name: SecretRouteName.LogDetails,
                    component: () => import('@/views/system/secrets/Index.vue'),
                    meta: {
                        label: 'Log Details',
                        auth: true,
                        permission: Permission.EventView,
                    },
                },
            ],
        },
    ],
}
